import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormInput, FormItem, HStretched } from '../../../../components';

const RequestDetailsSection = () => {
  const { t } = useTranslation();

  return (
    <>
      <HStretched _justify="flex-start">
        <FormItem
          label={t('REQUEST.ORDER_NUMBER')}
          name="internalId"
          rules={[{ required: true, message: t('REQUEST.TRANSPORT_ORDER_NUMBER_MISSING') },
            { type: 'string', max: 50, message: t('COMMON.VALIDATION.MAX_50') },
            {
              pattern: new RegExp('^[a-zA-Z0-9-_]+$'),
              type: 'string',
              message: t('REQUEST.TRANSPORT_ORDER_NUMBER_INVALID_CHARACTERS'),
            }]}
        >
          <FormInput placeholder={t('REQUEST.TRANSPORT_ORDER_NUMBER_PROMPT')} />
        </FormItem>
        <FormItem
          label={t('REQUEST.ADDITIONAL_INFO')}
          name="shipperName"
        >
          <FormInput placeholder={t('REQUEST.ADDITIONAL_INFO_PROMPT')} />
        </FormItem>
      </HStretched>
    </>
  );
};

export default RequestDetailsSection;
